import React from "react";
import ReactDOM from "react-dom/client";
// Contexts
import { NavProvider } from "./contexts/NavContext";
// Components
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <NavProvider>
      <App />
    </NavProvider>
  </React.StrictMode>
);
